// extracted by mini-css-extract-plugin
export default {"GroupHeading":"GYkaSF2e"};